import React, { Component } from 'react';

import assign from 'object-assign';
// components
import AssetCard from './AssetCard';
import { Card, CardActions, CardText } from 'material-ui/Card';

import DetailView from '../Common/DetailView';
import FlatButton from 'material-ui/FlatButton';
import { Form } from 'formsy-react';
import LinearProgress from 'material-ui/LinearProgress';
import TextField from 'material-ui/TextField';
// business logic
import AssetActions from '../../actions/AssetActionCreator';
import AppStore from '../../stores/AppStore';
import {isSurroundedBy} from "../../utils/StringUtils";

class AssetSearch extends Component {

    constructor (props) {
        super(props);
        this.state = {
            loading: false,
            search: '',
            searchField: '',
            assets: [],
            allowSearch: false
        };
        this.onChange = this.onChange.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.searchAssets = this.searchAssets.bind(this);
    }

    componentDidMount() {
        AppStore.addSearchResultListener(this.onChange);
    }

    componentWillUnmount() {
        AppStore.removeSearchResultListener(this.onChange);
    }

    render() {

        let nameFieldProps = {
            value:              this.state.searchField,
            floatingLabelText:  'Search text',
            onChange:           this.onTextChange,
            fullWidth: true
        };

        let progress;
        if (this.state.loading) {
            progress = <LinearProgress mode="indeterminate" />;
        }

        return (
            <DetailView
                title="Assets"
                backButton={true}
            >
                <Form onValidSubmit={this.searchAssets} >
                    <div className="cent-cards">
                        <Card className="cent-card">
                            <CardText>
                                <TextField {...nameFieldProps} />
                            </CardText>
                            <CardActions>
                                <FlatButton type="Submit" label="Search" disabled={!this.state.allowSearch} />
                            </CardActions>
                            {progress}
                        </Card>
                    </div>
                </Form>
                <div className="cent-cards">
                    {this.state.assets.map((asset) => <AssetCard data={asset} key={asset.id} search={this.state.search}/>)}
                </div>
            </DetailView>
        );
    }
    
    onChange() {
        let state = assign(this.state, { assets: AppStore.getSearchResult(), loading: false });
        this.setState(state);
    }
    
    onTextChange({target}) {
        this.setState({searchField: target.value, allowSearch: target.value.length > (isSurroundedBy(target.value, '"') ? 4 : 2)});
    }
    
    searchAssets() {
        if (this.state.searchField.length >= 3) {
            this.setState({loading: true, assets: [], search: this.state.searchField});
            let search, matchEntireText = false;

            if (isSurroundedBy(this.state.searchField, '"')) {
                search = this.state.searchField.slice(1, this.state.searchField.length - 1);
                matchEntireText = true;
            } else {
                search = this.state.searchField;
            }

            AssetActions.searchContents(search, {matchEntireText});
        }
    }

}

export default AssetSearch;
